import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BaseStatistic from 'antd/es/statistic';

const verticalAlign = {
  top: 'column',
  bottom: 'column-reverse',
  left: 'row',
  right: 'row-reverse',
};

const horizontalAlign = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center',
};

const StyledStatistics = styled(BaseStatistic)`
  display: flex;
  flex-direction: ${props => props.direction};
  justify-content: center;
  align-items: center;

  & .ant-statistic-title {
    justify-self: ${props => props.justifySelf};
    align-self: ${props => props.alignSelf};
    text-align: center;
    color: #000
  }
`;

const Statistics = ({ titleAlign, ...rest }) => {
  const [horizontal, vertical] = titleAlign;

  const direction = verticalAlign[vertical] || 'column';
  let justifySelf = 'center', alignSelf = 'center';

  if (direction.includes('row')) {
    justifySelf = horizontalAlign[horizontal || 'center'];
  } else {
    alignSelf = horizontalAlign[horizontal || 'center'];
  }

  return (
    <StyledStatistics
      direction={direction}
      justifySelf={justifySelf}
      alignSelf={alignSelf}
      {...rest}
    />
  );
}

Statistics.propTypes = {
  titleAlign: PropTypes.arrayOf(PropTypes.string),
};

Statistics.defaultProps = {
  titleAlign: ['center', 'top'],
};

export default Statistics;
